var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 417,
    viewBox: "0 0 363 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.289 0.290751V240.104",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.572 240.216L359.212 177.35L361.852 114.489L364.491 51.6359L366.536 2.8702",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.838 240.536L367.118 177.837L372.393 115.143L377.668 52.4438L381.41 7.97165",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2661 498.927L60.595 487.88L118.738 463.491L176.873 439.102L235.016 414.708",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2937 486.178L55.7395 475.623L114.847 453.684L173.958 431.745L233.07 409.802",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8999 473.062L51.3986 463.175L111.376 443.725L171.357 424.28L231.334 404.825",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.187 459.578L47.5881 450.55L108.328 433.627L169.068 416.701L229.812 399.778",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2632 445.751L44.3229 437.78L105.718 423.41L167.11 409.041L228.506 394.672",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25269 431.618L41.5936 424.887L103.533 413.096L165.473 401.306L227.418 389.511",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28345 417.214L39.4128 411.89L101.786 402.695L164.163 393.505L226.544 384.315",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4873 402.622L37.7797 398.816L100.482 392.239L163.185 385.661L225.888 379.084",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.978027 387.923L36.6917 385.682L99.6088 381.731L162.53 377.784L225.455 373.832",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85229 373.234L36.1477 372.516L99.1717 371.198L162.204 369.881L225.237 368.564",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78027 358.667L36.1473 359.343L99.1713 360.66L162.204 361.978L225.237 363.295",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82666 344.299L36.6909 346.176L99.608 350.128L162.529 354.079L225.455 358.031",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3521 330.272L37.7795 333.043L100.482 339.625L163.185 346.198L225.887 352.775",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.926 316.805L39.4125 319.973L101.785 329.164L164.162 338.354L226.544 347.549",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4258 304.274L41.5931 306.977L103.533 318.763L165.473 330.558L227.417 342.349",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2722 293.364L44.3233 294.079L105.719 308.452L167.11 322.817L228.506 337.187",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4211 285.162L108.328 298.231L169.068 315.157L229.812 332.08",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2173 280.624L111.375 288.134L171.357 307.584L231.334 327.034",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.31 278.346L173.959 300.118L233.07 322.057",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M136.376 275.771L176.872 292.757L235.015 317.151",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.837 272.264L180.099 285.539L237.162 312.336",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.601 268.009L183.626 278.457L239.515 307.615",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.942 263.172L187.443 271.524L242.06 302.996",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.643 257.856L191.554 264.762L244.799 298.483",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.161 252.091L195.941 258.18L247.729 294.099",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.797 245.878L200.605 251.788L250.833 289.833",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.75 239.168L205.532 245.591L254.119 285.705",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M202.147 231.911L210.709 239.604L257.569 281.716",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M206.082 224.02L216.135 233.844L261.182 277.871",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.608 215.359L221.795 228.309L264.957 274.184",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M268.882 270.656L227.679 223.019L212.406 205.361C212.406 205.357 212.406 205.357 212.406 205.357",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M215.311 194.721L233.781 217.977L272.953 267.299",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.444 183.456L240.093 213.187L277.157 264.104",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.86 171.517L246.599 208.676L281.494 261.099",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.626 158.858L253.28 204.433L285.955 258.262",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 145.429L260.148 200.477L290.527 255.628",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M234.544 131.223L239.125 140.435L267.164 196.809L295.207 253.182",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M239.897 116.242L248.686 135.94L274.334 193.438L299.99 250.937",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.015 100.573L258.426 131.856L281.643 190.376L304.861 248.897",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M253.048 84.3859L268.329 128.182L289.07 187.622L309.811 247.062",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261.151 67.9852L278.383 124.932L296.608 185.185L314.838 245.433",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M270.481 51.8369L272.881 61.1512L288.561 122.105L304.245 183.068L319.925 244.018",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M281.146 36.6032L285.74 58.1615L298.849 119.714L311.958 181.267L325.071 242.824",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M293.188 23.1029L298.712 55.7076L309.228 117.752L319.744 179.797L330.261 241.845",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M306.511 12.1763L311.782 53.8045L319.685 116.23L327.587 178.655L335.489 241.084",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M320.885 4.55525L324.913 52.4443L330.188 115.143L335.463 177.838L340.743 240.537",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M335.948 0.642143L338.09 51.636L340.73 114.489L343.37 177.35L346.01 240.216",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperRight);
export default __webpack_public_path__ + "static/media/eliminate-paper-right.d5876e6a2d5cbe3e6898ce1412b2cce4.svg";
export { ForwardRef as ReactComponent };